const base64ToBlob = (base64: string): Blob => {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: 'application/pdf' });
};

const triggerBlobDownload = (blob: Blob, fileName: string): void => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const downloadPdfFromBase64 = (
  base64: string,
  fileName: string
): void => {
  triggerBlobDownload(base64ToBlob(base64), fileName);
};

export const openPdfInNewTab = (base64: string): void => {
  const blob = base64ToBlob(base64);
  const url = URL.createObjectURL(blob);
  window.open(url, '_blank');
};

export const downloadCertificateFromApi = async (
  eventNum: number
): Promise<void> => {
  const { CertificateApi } = await import(
    '@api/bff/openapi/endpoints/certificate-api'
  );
  const { bffApiClient } = await import('@api/bff/client');

  const certificateApi = new CertificateApi(undefined, undefined, bffApiClient);

  const response = await certificateApi.apiCertificatesEventNumDownloadGet(
    { eventNum },
    { responseType: 'blob' }
  );

  const disposition = response.headers['content-disposition'] as
    | string
    | undefined;
  let fileName = `certificate-${eventNum}.pdf`;
  if (disposition) {
    const match = disposition.match(/filename\*?=(?:UTF-8''|"?)([^";]+)/i);
    if (match?.[1]) {
      fileName = decodeURIComponent(match[1].replace(/"/g, ''));
    }
  }

  triggerBlobDownload(response.data as unknown as Blob, fileName);
};
